// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"244e5615","515":"bd04b772","739":"6501b94e"}[chunkId] + ".chunk.js";
};